import { useFormik } from 'formik'
import { Link } from 'react-router-dom'
import { object, string } from 'yup'
import Button from '~/app/components/utils/Button/Button'
import Input from '~/app/components/utils/Input/Input'
import Text from '~/app/components/utils/Text/Text'
import { AUTH_PATH } from '~/app/lib/paths'
import { useSignIn } from '~/app/services/auth/auth.hook'

const SignInSchema = object().shape({
  email: string().email('Invalid email').required('Email is required'),
  password: string().min(8, 'Password must be at least 8 characters').required('Password is required'),
})

const SignInForm = () => {
  const { mutateAsync: signIn, isPending } = useSignIn()
  const formik = useFormik({
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: SignInSchema,
    initialValues: {
      email: '',
      password: '',
    },
    onSubmit: (values) => {
      signIn(values)
    },
  })

  return (
    <div className="w-full space-y-5">
      <Input
        label="Email"
        type="email"
        required
        placeholder="Enter your email"
        {...formik.getFieldProps('email')}
        error={formik.touched.email ? formik.errors.email : undefined}
        onEnter={formik.submitForm}
      />
      <Input
        label="Password"
        required
        type="password"
        placeholder="Enter your password"
        labelExtra={
          <Link to={AUTH_PATH.FORGOT_PASSWORD}>
            <Text type="title-3" color="accent-green">
              Forgot password?
            </Text>
          </Link>
        }
        {...formik.getFieldProps('password')}
        error={formik.touched.password ? formik.errors.password : undefined}
        onEnter={formik.submitForm}
      />
      <Button className="w-full" onClick={formik.submitForm} loading={isPending}>
        <Text type="title-3">Sign in</Text>
      </Button>
    </div>
  )
}

export default SignInForm
